import { CognitoUserPool } from 'amazon-cognito-identity-js';

// Cognito configuration - only initialize if env vars are present
const poolData = {
  UserPoolId: process.env.REACT_APP_POOL_ID || 'placeholder',
  ClientId: process.env.REACT_APP_CLIENT_ID || 'placeholder',
};

// Only create UserPool if we have real credentials
export const UserPool =
  process.env.REACT_APP_POOL_ID && process.env.REACT_APP_CLIENT_ID
    ? new CognitoUserPool(poolData)
    : null;

export const googleID = process.env.REACT_APP_GOOGLE_ID;

export const navLinks = [{ name: 'HOME', path: '' }];

export const footerLinks = [
  { name: 'ABOUT', path: 'about' },
  { name: 'PRIVACY POLICY', path: 'privacy-policy' },
  { name: 'TERMS OF USE', path: 'terms-of-use' },
  { name: 'AFFILIATE DISCLOSURE', path: 'affiliate-disclosure' },
];

export const partsForEachWeaponType = {
  pistol: {
    HARDWARE: [
      'LOWER RECEIVER',
      'BARREL',
      'SLIDE',
      'TRIGGER',
      'RECOIL SPRING',
      'SLIDE RELEASE',
      'MAGAZINE RELEASE',
      'SAFETY',
    ],
    ATTACHMENTS: [
      'IRON SIGHT',
      'OPTIC',
      'UNDERBARREL ATTACHMENTS',
      'MUZZLE DEVICE',
      'STOCK',
      'LIGHT/LASER/IR',
    ],
    ACCESSORIES: [
      'SLING',
      'MAGAZINE',
      'SPEED LOADER',
      'CASES',
      'OTHER ACCESSORIES',
    ],
  },
  rifle: {
    HARDWARE: [
      'UPPER RECEIVER',
      'LOWER RECEIVER',
      'BARREL',
      'HANDGUARD',
      'GAS TUBE & GAS BLOCK',
      'BOLT CARRIER GROUP',
      'CHARGING HANDLE',
      'TRIGGER GUARD',
      'TRIGGER',
      'REAR GRIP',
      'TAKE DOWN PIN',
      'BUFFER TUBE & BUFFER',
      'SAFETY',
      'MAGAZINE RELEASE',
      'BOLT RELEASE',
    ],
    ATTACHMENTS: [
      'IRON SIGHT',
      'OPTIC',
      'UNDERBARREL ATTACHMENTS',
      'MUZZLE DEVICE',
      'STOCK',
      'LIGHT/LASER/IR',
    ],
    ACCESSORIES: [
      'SLING',
      'MAGAZINE',
      'EJECTION PORT COVER',
      'CHEEK RISER',
      'SPEED LOADER',
      'CASES',
      'OTHER ACCESSORIES',
    ],
  },
  shotgun: {
    HARDWARE: [
      'BARREL',
      'FOREND',
      'MAGAZINE TUBE',
      'FOLLOWER',
      'SAFETY',
      'TRIGGER',
      'REAR GRIP',
    ],
    ATTACHMENTS: [
      'IRON SIGHT',
      'OPTIC',
      'UNDERBARREL ATTACHMENTS',
      'MUZZLE DEVICE',
      'STOCK',
      'LIGHT/LASER/IR',
    ],
    ACCESSORIES: ['SLING', 'SPEED LOADER', 'CASES', 'OTHER ACCESSORIES'],
  },
};